import Vue from 'vue';
import App from './App';

//import Axios from 'axios'
import store from './store';

import router from './app-routes';

require('./public/style.css')

import moment from 'moment'

Vue.filter('formatDate', function(value) {
    if (value) {
      return moment(String(value)).format('DD.MM.YYYY HH:mm')
    }
});

/**
 * Mount the Vue instance on the DOM element "#wp-vue-app" in the Custom Page Template
 */

new Vue({
	el: '#wp-vue-app',
	router,
	store,
	render: h => h( App )
});



// WEBPACK FOOTER //
// ./src/main.js